var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text-center py-6 elevation-1 rounded-sm",
      attrs: { "data-qa": "appointment_express_only_phone" },
    },
    [
      _c("div", { staticClass: "text-body-1 text-secondary--text mb-1" }, [
        _vm._v(
          "\n    " +
            _vm._s(_setup.t("Запись по телефону", _setup.options)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            "a",
            {
              staticClass: "text-h4 primary--text text-decoration-none",
              attrs: { href: `tel:${_setup.lpuDataStore.phoneRaw}` },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_setup.lpuDataStore.phonePublic) + "\n  "
              ),
            ]
          )
        : _c("div", { staticClass: "text-h3 text--text" }, [
            _vm._v("\n    " + _vm._s(_setup.lpuDataStore.phonePublic) + "\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }